import React, { FC, HTMLAttributes } from 'react';
import { FormattedMessage } from 'react-intl';
import styled, { css } from 'styled-components';
import { globalTheme } from '@cld/component-theme';
import { typography, TypographySize } from '@cld/typography';
import {
  SMALL_SELECTABLES_ITEM_CONTENT_HEIGHT,
  SMALL_SELECTABLES_ITEM_CONTENT_WIDTH,
  SMALL_SELECTABLES_ITEM_WIDTH,
} from '../../../common/selectable/containers/SmallSelectabes';
import { Selectable } from '../../../common/selectable/Selectable';
import { TextPresetName, TextPresetState } from '../../../../../types';
import { messages } from '../../../../../i18n';

const sizeByOverlayName = {
  heading: 'lg',
  subtitle: 'md',
  body: 'sm',
  caption: 'xxs',
} as Record<TextPresetName, TypographySize>;

const familyByOverlayName = {
  heading: 'Georgia',
  subtitle: 'Arial',
  body: 'Roboto',
  caption: 'Montserrat',
};

export const Overlay = styled.div<{ overlayName: TextPresetName }>`
  padding: ${globalTheme.spacing.xxs};
  width: ${SMALL_SELECTABLES_ITEM_CONTENT_WIDTH}px;
  height: ${SMALL_SELECTABLES_ITEM_CONTENT_HEIGHT}px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: ${globalTheme.palette.contrastLow};
  font-family: ${(props) => `${familyByOverlayName[props.overlayName]}, sans-serif`};
  ${(props) => typography[sizeByOverlayName[props.overlayName]].regular};
`;

const Text = styled.div`
  ${typography.xxs.regular};
  text-align: center;
  padding-top: ${globalTheme.spacing.xxs};
`;
const Root = styled.div`
  margin-right: ${globalTheme.spacing.xxs};
  width: ${SMALL_SELECTABLES_ITEM_WIDTH}px;
`;

interface PresetOptionProps extends HTMLAttributes<HTMLDivElement> {
  overlayName: TextPresetName;
  textPresets: TextPresetState;
}

export const PresetOption: FC<PresetOptionProps> = ({ overlayName, textPresets, onClick }) => {
  const presetMessages = {
    heading: messages['section.textOverlays.presets.heading'],
    subtitle: messages['section.textOverlays.presets.subtitle'],
    body: messages['section.textOverlays.presets.body'],
    caption: messages['section.textOverlays.presets.caption'],
  };
  return (
    <Root key={overlayName}>
      <Selectable isSelected={textPresets[overlayName]} onClick={onClick}>
        <Overlay overlayName={overlayName}>ABC</Overlay>
      </Selectable>
      <Text>
        <FormattedMessage {...presetMessages[overlayName]} />
      </Text>
    </Root>
  );
};
